import React from 'react';
import Breadcrumb from 'src/components/breadcrumb';
import SearchBar from './SearchBar';

interface HeaderProps {
    searchTerm: string;
    onSearch: (searchTerm: string) => void;
    onAddUser: () => void;
}

const Header: React.FC<HeaderProps> = ({ searchTerm, onSearch, onAddUser }) => {
    return (
        <>
            <div className="flex justify-between mb-4 sm:mb-6">
                <Breadcrumb title="User Management" />
                <div className="flex sm:hidden">
                    <button
                        id="add-user-btn-mobile"
                        className="btn-primary text-[24px] sm:text-[16px] rounded-full sm:text-body w-fit sm:w-auto sm:rounded-[8px]"
                        onClick={onAddUser}
                    >
                        <span className=""> + </span>
                    </button>
                </div>
            </div>

            <div className="bg-white rounded-card shadow overflow-hidden p-3 sm:p-4 mb-4">
                <div className="flex items-center justify-between">
                    <SearchBar 
                        initialSearchTerm={searchTerm} 
                        onSearch={onSearch} 
                    />
                    <div className="hidden sm:flex flex-wrap items-center gap-2 sm:gap-3 w-full sm:w-auto justify-end">
                        <button
                            id="add-user-btn"
                            className="btn-primary text-[24px] sm:text-[16px] rounded-full sm:text-body w-fit sm:w-auto sm:rounded-[8px]"
                            onClick={onAddUser}
                        >
                            <span className=""> + </span>
                            <span className="ml-1 hidden sm:inline">
                                Add User
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Header;
